import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _24664ccf = () => interopDefault(import('../diptyqueTheme/pages/Home.vue' /* webpackChunkName: "" */))
const _41c4ca90 = () => interopDefault(import('../diptyqueTheme/pages/Cart.vue' /* webpackChunkName: "" */))
const _6efdbb4e = () => interopDefault(import('../modules/one-page-checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _7604683d = () => interopDefault(import('../diptyqueTheme/pages/ConfirmSubscription.vue' /* webpackChunkName: "" */))
const _080f4ae0 = () => interopDefault(import('../diptyqueTheme/pages/Contact.vue' /* webpackChunkName: "" */))
const _99764fe6 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _1e702f0a = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _f03af7ee = () => interopDefault(import('../modules/customer/pages/MyAccount/MyNewsletter.vue' /* webpackChunkName: "" */))
const _e14bfbc2 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyPaymentMethods/index.vue' /* webpackChunkName: "" */))
const _a52c4f92 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _9fb7ec8a = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _f80a34f2 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _0b66dc33 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _ccf4d350 = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _b7c9810a = () => interopDefault(import('../diptyqueTheme/pages/ExternalCart.vue' /* webpackChunkName: "" */))
const _10713838 = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "pages/Home" */))
const _f36f98ae = () => interopDefault(import('../diptyqueTheme/pages/Login.vue' /* webpackChunkName: "" */))
const _60a64de8 = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _c1413e6c = () => interopDefault(import('../diptyqueTheme/pages/ResetPassword.vue' /* webpackChunkName: "" */))
const _45c71dcf = () => interopDefault(import('../modules/algolia-search/pages/Search/Search.vue' /* webpackChunkName: "" */))
const _a842437e = () => interopDefault(import('../modules/one-page-checkout/pages/checkout/ErrorPage.vue' /* webpackChunkName: "" */))
const _4af5c43b = () => interopDefault(import('../modules/one-page-checkout/pages/checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _30614006 = () => interopDefault(import('../integrations/adyen/pages/AfterPaymentPage.vue' /* webpackChunkName: "" */))
const _7d2a12c3 = () => interopDefault(import('../diptyqueTheme/modules/gmo-payment/pages/LinkTypePlusReturn.vue' /* webpackChunkName: "" */))
const _28c16772 = () => interopDefault(import('../diptyqueTheme/modules/gmo-payment/pages/ThreeDSecureReturn.vue' /* webpackChunkName: "" */))
const _749b627f = () => interopDefault(import('../diptyqueTheme/pages/Page.vue' /* webpackChunkName: "" */))
const _46857d16 = () => interopDefault(import('../modules/catalog/pages/category.vue' /* webpackChunkName: "" */))
const _106cd748 = () => interopDefault(import('../modules/catalog/pages/product.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/de_eu",
    component: _24664ccf,
    name: "home___de_eu"
  }, {
    path: "/en_eu",
    component: _24664ccf,
    name: "home___en_eu"
  }, {
    path: "/en_hk",
    component: _24664ccf,
    name: "home___en_hk"
  }, {
    path: "/en_uk",
    component: _24664ccf,
    name: "home___en_uk"
  }, {
    path: "/en_us",
    component: _24664ccf,
    name: "home___en_us"
  }, {
    path: "/en_us",
    component: _24664ccf,
    name: "home___en_us"
  }, {
    path: "/es_eu",
    component: _24664ccf,
    name: "home___es_eu"
  }, {
    path: "/fr_eu",
    component: _24664ccf,
    name: "home___fr_eu"
  }, {
    path: "/fr_fr",
    component: _24664ccf,
    name: "home___fr_fr"
  }, {
    path: "/fr_us",
    component: _24664ccf,
    name: "home___fr_us"
  }, {
    path: "/fr_us",
    component: _24664ccf,
    name: "home___fr_us"
  }, {
    path: "/it_eu",
    component: _24664ccf,
    name: "home___it_eu"
  }, {
    path: "/ja_jp",
    component: _24664ccf,
    name: "home___ja_jp"
  }, {
    path: "/zh_hk",
    component: _24664ccf,
    name: "home___zh_hk"
  }, {
    path: "/de_eu/cart",
    component: _41c4ca90,
    name: "cart___de_eu"
  }, {
    path: "/de_eu/checkout",
    component: _6efdbb4e,
    name: "checkout___de_eu"
  }, {
    path: "/de_eu/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___de_eu"
  }, {
    path: "/de_eu/contact",
    component: _080f4ae0,
    name: "contact___de_eu"
  }, {
    path: "/de_eu/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___de_eu",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___de_eu"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___de_eu"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___de_eu"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___de_eu"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___de_eu"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___de_eu"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___de_eu"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___de_eu"
    }]
  }, {
    path: "/de_eu/external-cart",
    component: _b7c9810a,
    name: "external-cart___de_eu"
  }, {
    path: "/de_eu/Home",
    component: _10713838,
    name: "Home___de_eu"
  }, {
    path: "/de_eu/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___de_eu"
  }, {
    path: "/de_eu/Page",
    component: _60a64de8,
    name: "Page___de_eu"
  }, {
    path: "/de_eu/reset-password",
    component: _c1413e6c,
    name: "reset-password___de_eu"
  }, {
    path: "/de_eu/search",
    component: _45c71dcf,
    name: "algolia-search___de_eu"
  }, {
    path: "/en_eu/cart",
    component: _41c4ca90,
    name: "cart___en_eu"
  }, {
    path: "/en_eu/checkout",
    component: _6efdbb4e,
    name: "checkout___en_eu"
  }, {
    path: "/en_eu/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___en_eu"
  }, {
    path: "/en_eu/contact",
    component: _080f4ae0,
    name: "contact___en_eu"
  }, {
    path: "/en_eu/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___en_eu",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___en_eu"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___en_eu"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___en_eu"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___en_eu"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___en_eu"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___en_eu"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___en_eu"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___en_eu"
    }]
  }, {
    path: "/en_eu/external-cart",
    component: _b7c9810a,
    name: "external-cart___en_eu"
  }, {
    path: "/en_eu/Home",
    component: _10713838,
    name: "Home___en_eu"
  }, {
    path: "/en_eu/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___en_eu"
  }, {
    path: "/en_eu/Page",
    component: _60a64de8,
    name: "Page___en_eu"
  }, {
    path: "/en_eu/reset-password",
    component: _c1413e6c,
    name: "reset-password___en_eu"
  }, {
    path: "/en_eu/search",
    component: _45c71dcf,
    name: "algolia-search___en_eu"
  }, {
    path: "/en_hk/cart",
    component: _41c4ca90,
    name: "cart___en_hk"
  }, {
    path: "/en_hk/checkout",
    component: _6efdbb4e,
    name: "checkout___en_hk"
  }, {
    path: "/en_hk/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___en_hk"
  }, {
    path: "/en_hk/contact",
    component: _080f4ae0,
    name: "contact___en_hk"
  }, {
    path: "/en_hk/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___en_hk",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___en_hk"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___en_hk"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___en_hk"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___en_hk"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___en_hk"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___en_hk"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___en_hk"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___en_hk"
    }]
  }, {
    path: "/en_hk/external-cart",
    component: _b7c9810a,
    name: "external-cart___en_hk"
  }, {
    path: "/en_hk/Home",
    component: _10713838,
    name: "Home___en_hk"
  }, {
    path: "/en_hk/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___en_hk"
  }, {
    path: "/en_hk/Page",
    component: _60a64de8,
    name: "Page___en_hk"
  }, {
    path: "/en_hk/reset-password",
    component: _c1413e6c,
    name: "reset-password___en_hk"
  }, {
    path: "/en_hk/search",
    component: _45c71dcf,
    name: "algolia-search___en_hk"
  }, {
    path: "/en_uk/cart",
    component: _41c4ca90,
    name: "cart___en_uk"
  }, {
    path: "/en_uk/checkout",
    component: _6efdbb4e,
    name: "checkout___en_uk"
  }, {
    path: "/en_uk/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___en_uk"
  }, {
    path: "/en_uk/contact",
    component: _080f4ae0,
    name: "contact___en_uk"
  }, {
    path: "/en_uk/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___en_uk",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___en_uk"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___en_uk"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___en_uk"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___en_uk"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___en_uk"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___en_uk"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___en_uk"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___en_uk"
    }]
  }, {
    path: "/en_uk/external-cart",
    component: _b7c9810a,
    name: "external-cart___en_uk"
  }, {
    path: "/en_uk/Home",
    component: _10713838,
    name: "Home___en_uk"
  }, {
    path: "/en_uk/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___en_uk"
  }, {
    path: "/en_uk/Page",
    component: _60a64de8,
    name: "Page___en_uk"
  }, {
    path: "/en_uk/reset-password",
    component: _c1413e6c,
    name: "reset-password___en_uk"
  }, {
    path: "/en_uk/search",
    component: _45c71dcf,
    name: "algolia-search___en_uk"
  }, {
    path: "/en_us/cart",
    component: _41c4ca90,
    name: "cart___en_us"
  }, {
    path: "/en_us/cart",
    component: _41c4ca90,
    name: "cart___en_us"
  }, {
    path: "/en_us/checkout",
    component: _6efdbb4e,
    name: "checkout___en_us"
  }, {
    path: "/en_us/checkout",
    component: _6efdbb4e,
    name: "checkout___en_us"
  }, {
    path: "/en_us/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___en_us"
  }, {
    path: "/en_us/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___en_us"
  }, {
    path: "/en_us/contact",
    component: _080f4ae0,
    name: "contact___en_us"
  }, {
    path: "/en_us/contact",
    component: _080f4ae0,
    name: "contact___en_us"
  }, {
    path: "/en_us/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___en_us",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___en_us"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___en_us"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___en_us"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___en_us"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___en_us"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___en_us"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___en_us"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___en_us"
    }]
  }, {
    path: "/en_us/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___en_us",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___en_us"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___en_us"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___en_us"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___en_us"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___en_us"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___en_us"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___en_us"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___en_us"
    }]
  }, {
    path: "/en_us/external-cart",
    component: _b7c9810a,
    name: "external-cart___en_us"
  }, {
    path: "/en_us/external-cart",
    component: _b7c9810a,
    name: "external-cart___en_us"
  }, {
    path: "/en_us/Home",
    component: _10713838,
    name: "Home___en_us"
  }, {
    path: "/en_us/Home",
    component: _10713838,
    name: "Home___en_us"
  }, {
    path: "/en_us/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___en_us"
  }, {
    path: "/en_us/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___en_us"
  }, {
    path: "/en_us/Page",
    component: _60a64de8,
    name: "Page___en_us"
  }, {
    path: "/en_us/Page",
    component: _60a64de8,
    name: "Page___en_us"
  }, {
    path: "/en_us/reset-password",
    component: _c1413e6c,
    name: "reset-password___en_us"
  }, {
    path: "/en_us/reset-password",
    component: _c1413e6c,
    name: "reset-password___en_us"
  }, {
    path: "/en_us/search",
    component: _45c71dcf,
    name: "algolia-search___en_us"
  }, {
    path: "/en_us/search",
    component: _45c71dcf,
    name: "algolia-search___en_us"
  }, {
    path: "/es_eu/cart",
    component: _41c4ca90,
    name: "cart___es_eu"
  }, {
    path: "/es_eu/checkout",
    component: _6efdbb4e,
    name: "checkout___es_eu"
  }, {
    path: "/es_eu/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___es_eu"
  }, {
    path: "/es_eu/contact",
    component: _080f4ae0,
    name: "contact___es_eu"
  }, {
    path: "/es_eu/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___es_eu",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___es_eu"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___es_eu"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___es_eu"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___es_eu"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___es_eu"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___es_eu"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___es_eu"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___es_eu"
    }]
  }, {
    path: "/es_eu/external-cart",
    component: _b7c9810a,
    name: "external-cart___es_eu"
  }, {
    path: "/es_eu/Home",
    component: _10713838,
    name: "Home___es_eu"
  }, {
    path: "/es_eu/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___es_eu"
  }, {
    path: "/es_eu/Page",
    component: _60a64de8,
    name: "Page___es_eu"
  }, {
    path: "/es_eu/reset-password",
    component: _c1413e6c,
    name: "reset-password___es_eu"
  }, {
    path: "/es_eu/search",
    component: _45c71dcf,
    name: "algolia-search___es_eu"
  }, {
    path: "/fr_eu/cart",
    component: _41c4ca90,
    name: "cart___fr_eu"
  }, {
    path: "/fr_eu/checkout",
    component: _6efdbb4e,
    name: "checkout___fr_eu"
  }, {
    path: "/fr_eu/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___fr_eu"
  }, {
    path: "/fr_eu/contact",
    component: _080f4ae0,
    name: "contact___fr_eu"
  }, {
    path: "/fr_eu/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___fr_eu",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___fr_eu"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___fr_eu"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___fr_eu"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___fr_eu"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___fr_eu"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___fr_eu"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___fr_eu"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___fr_eu"
    }]
  }, {
    path: "/fr_eu/external-cart",
    component: _b7c9810a,
    name: "external-cart___fr_eu"
  }, {
    path: "/fr_eu/Home",
    component: _10713838,
    name: "Home___fr_eu"
  }, {
    path: "/fr_eu/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___fr_eu"
  }, {
    path: "/fr_eu/Page",
    component: _60a64de8,
    name: "Page___fr_eu"
  }, {
    path: "/fr_eu/reset-password",
    component: _c1413e6c,
    name: "reset-password___fr_eu"
  }, {
    path: "/fr_eu/search",
    component: _45c71dcf,
    name: "algolia-search___fr_eu"
  }, {
    path: "/fr_fr/cart",
    component: _41c4ca90,
    name: "cart___fr_fr"
  }, {
    path: "/fr_fr/checkout",
    component: _6efdbb4e,
    name: "checkout___fr_fr"
  }, {
    path: "/fr_fr/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___fr_fr"
  }, {
    path: "/fr_fr/contact",
    component: _080f4ae0,
    name: "contact___fr_fr"
  }, {
    path: "/fr_fr/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___fr_fr",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___fr_fr"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___fr_fr"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___fr_fr"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___fr_fr"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___fr_fr"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___fr_fr"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___fr_fr"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___fr_fr"
    }]
  }, {
    path: "/fr_fr/external-cart",
    component: _b7c9810a,
    name: "external-cart___fr_fr"
  }, {
    path: "/fr_fr/Home",
    component: _10713838,
    name: "Home___fr_fr"
  }, {
    path: "/fr_fr/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___fr_fr"
  }, {
    path: "/fr_fr/Page",
    component: _60a64de8,
    name: "Page___fr_fr"
  }, {
    path: "/fr_fr/reset-password",
    component: _c1413e6c,
    name: "reset-password___fr_fr"
  }, {
    path: "/fr_fr/search",
    component: _45c71dcf,
    name: "algolia-search___fr_fr"
  }, {
    path: "/fr_us/cart",
    component: _41c4ca90,
    name: "cart___fr_us"
  }, {
    path: "/fr_us/cart",
    component: _41c4ca90,
    name: "cart___fr_us"
  }, {
    path: "/fr_us/checkout",
    component: _6efdbb4e,
    name: "checkout___fr_us"
  }, {
    path: "/fr_us/checkout",
    component: _6efdbb4e,
    name: "checkout___fr_us"
  }, {
    path: "/fr_us/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___fr_us"
  }, {
    path: "/fr_us/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___fr_us"
  }, {
    path: "/fr_us/contact",
    component: _080f4ae0,
    name: "contact___fr_us"
  }, {
    path: "/fr_us/contact",
    component: _080f4ae0,
    name: "contact___fr_us"
  }, {
    path: "/fr_us/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___fr_us",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___fr_us"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___fr_us"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___fr_us"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___fr_us"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___fr_us"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___fr_us"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___fr_us"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___fr_us"
    }]
  }, {
    path: "/fr_us/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___fr_us",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___fr_us"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___fr_us"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___fr_us"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___fr_us"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___fr_us"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___fr_us"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___fr_us"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___fr_us"
    }]
  }, {
    path: "/fr_us/external-cart",
    component: _b7c9810a,
    name: "external-cart___fr_us"
  }, {
    path: "/fr_us/external-cart",
    component: _b7c9810a,
    name: "external-cart___fr_us"
  }, {
    path: "/fr_us/Home",
    component: _10713838,
    name: "Home___fr_us"
  }, {
    path: "/fr_us/Home",
    component: _10713838,
    name: "Home___fr_us"
  }, {
    path: "/fr_us/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___fr_us"
  }, {
    path: "/fr_us/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___fr_us"
  }, {
    path: "/fr_us/Page",
    component: _60a64de8,
    name: "Page___fr_us"
  }, {
    path: "/fr_us/Page",
    component: _60a64de8,
    name: "Page___fr_us"
  }, {
    path: "/fr_us/reset-password",
    component: _c1413e6c,
    name: "reset-password___fr_us"
  }, {
    path: "/fr_us/reset-password",
    component: _c1413e6c,
    name: "reset-password___fr_us"
  }, {
    path: "/fr_us/search",
    component: _45c71dcf,
    name: "algolia-search___fr_us"
  }, {
    path: "/fr_us/search",
    component: _45c71dcf,
    name: "algolia-search___fr_us"
  }, {
    path: "/it_eu/cart",
    component: _41c4ca90,
    name: "cart___it_eu"
  }, {
    path: "/it_eu/checkout",
    component: _6efdbb4e,
    name: "checkout___it_eu"
  }, {
    path: "/it_eu/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___it_eu"
  }, {
    path: "/it_eu/contact",
    component: _080f4ae0,
    name: "contact___it_eu"
  }, {
    path: "/it_eu/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___it_eu",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___it_eu"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___it_eu"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___it_eu"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___it_eu"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___it_eu"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___it_eu"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___it_eu"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___it_eu"
    }]
  }, {
    path: "/it_eu/external-cart",
    component: _b7c9810a,
    name: "external-cart___it_eu"
  }, {
    path: "/it_eu/Home",
    component: _10713838,
    name: "Home___it_eu"
  }, {
    path: "/it_eu/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___it_eu"
  }, {
    path: "/it_eu/Page",
    component: _60a64de8,
    name: "Page___it_eu"
  }, {
    path: "/it_eu/reset-password",
    component: _c1413e6c,
    name: "reset-password___it_eu"
  }, {
    path: "/it_eu/search",
    component: _45c71dcf,
    name: "algolia-search___it_eu"
  }, {
    path: "/ja_jp/cart",
    component: _41c4ca90,
    name: "cart___ja_jp"
  }, {
    path: "/ja_jp/checkout",
    component: _6efdbb4e,
    name: "checkout___ja_jp"
  }, {
    path: "/ja_jp/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___ja_jp"
  }, {
    path: "/ja_jp/contact",
    component: _080f4ae0,
    name: "contact___ja_jp"
  }, {
    path: "/ja_jp/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___ja_jp",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___ja_jp"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___ja_jp"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___ja_jp"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___ja_jp"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___ja_jp"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___ja_jp"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___ja_jp"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___ja_jp"
    }]
  }, {
    path: "/ja_jp/external-cart",
    component: _b7c9810a,
    name: "external-cart___ja_jp"
  }, {
    path: "/ja_jp/Home",
    component: _10713838,
    name: "Home___ja_jp"
  }, {
    path: "/ja_jp/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___ja_jp"
  }, {
    path: "/ja_jp/Page",
    component: _60a64de8,
    name: "Page___ja_jp"
  }, {
    path: "/ja_jp/reset-password",
    component: _c1413e6c,
    name: "reset-password___ja_jp"
  }, {
    path: "/ja_jp/search",
    component: _45c71dcf,
    name: "algolia-search___ja_jp"
  }, {
    path: "/zh_hk/cart",
    component: _41c4ca90,
    name: "cart___zh_hk"
  }, {
    path: "/zh_hk/checkout",
    component: _6efdbb4e,
    name: "checkout___zh_hk"
  }, {
    path: "/zh_hk/confirm-subscription",
    component: _7604683d,
    name: "confirm-subscription___zh_hk"
  }, {
    path: "/zh_hk/contact",
    component: _080f4ae0,
    name: "contact___zh_hk"
  }, {
    path: "/zh_hk/customer",
    component: _99764fe6,
    meta: {"titleLabel":"Account | Diptyque Paris"},
    name: "customer___zh_hk",
    children: [{
      path: "addresses-details",
      component: _1e702f0a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details___zh_hk"
    }, {
      path: "my-newsletter",
      component: _f03af7ee,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-newsletter___zh_hk"
    }, {
      path: "my-payment-methods",
      component: _e14bfbc2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-vault-card-list___zh_hk"
    }, {
      path: "my-profile",
      component: _a52c4f92,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-my-profile___zh_hk"
    }, {
      path: "order-history",
      component: _9fb7ec8a,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-order-history___zh_hk"
    }, {
      path: "addresses-details/create",
      component: _f80a34f2,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      name: "customer-addresses-details-new___zh_hk"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0b66dc33,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-addresses-details-edit___zh_hk"
    }, {
      path: "order-history/:orderId",
      component: _ccf4d350,
      meta: {"titleLabel":"Account | Diptyque Paris"},
      props: true,
      name: "customer-single-order___zh_hk"
    }]
  }, {
    path: "/zh_hk/external-cart",
    component: _b7c9810a,
    name: "external-cart___zh_hk"
  }, {
    path: "/zh_hk/Home",
    component: _10713838,
    name: "Home___zh_hk"
  }, {
    path: "/zh_hk/login",
    component: _f36f98ae,
    meta: {"titleLabel":"Login"},
    name: "customer-login___zh_hk"
  }, {
    path: "/zh_hk/Page",
    component: _60a64de8,
    name: "Page___zh_hk"
  }, {
    path: "/zh_hk/reset-password",
    component: _c1413e6c,
    name: "reset-password___zh_hk"
  }, {
    path: "/zh_hk/search",
    component: _45c71dcf,
    name: "algolia-search___zh_hk"
  }, {
    path: "/de_eu/checkout/error-page",
    component: _a842437e,
    name: "error-page___de_eu"
  }, {
    path: "/de_eu/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___de_eu"
  }, {
    path: "/en_eu/checkout/error-page",
    component: _a842437e,
    name: "error-page___en_eu"
  }, {
    path: "/en_eu/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___en_eu"
  }, {
    path: "/en_hk/checkout/error-page",
    component: _a842437e,
    name: "error-page___en_hk"
  }, {
    path: "/en_hk/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___en_hk"
  }, {
    path: "/en_uk/checkout/error-page",
    component: _a842437e,
    name: "error-page___en_uk"
  }, {
    path: "/en_uk/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___en_uk"
  }, {
    path: "/en_us/checkout/error-page",
    component: _a842437e,
    name: "error-page___en_us"
  }, {
    path: "/en_us/checkout/error-page",
    component: _a842437e,
    name: "error-page___en_us"
  }, {
    path: "/en_us/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___en_us"
  }, {
    path: "/en_us/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___en_us"
  }, {
    path: "/es_eu/checkout/error-page",
    component: _a842437e,
    name: "error-page___es_eu"
  }, {
    path: "/es_eu/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___es_eu"
  }, {
    path: "/fr_eu/checkout/error-page",
    component: _a842437e,
    name: "error-page___fr_eu"
  }, {
    path: "/fr_eu/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___fr_eu"
  }, {
    path: "/fr_fr/checkout/error-page",
    component: _a842437e,
    name: "error-page___fr_fr"
  }, {
    path: "/fr_fr/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___fr_fr"
  }, {
    path: "/fr_us/checkout/error-page",
    component: _a842437e,
    name: "error-page___fr_us"
  }, {
    path: "/fr_us/checkout/error-page",
    component: _a842437e,
    name: "error-page___fr_us"
  }, {
    path: "/fr_us/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___fr_us"
  }, {
    path: "/fr_us/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___fr_us"
  }, {
    path: "/it_eu/checkout/error-page",
    component: _a842437e,
    name: "error-page___it_eu"
  }, {
    path: "/it_eu/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___it_eu"
  }, {
    path: "/ja_jp/checkout/error-page",
    component: _a842437e,
    name: "error-page___ja_jp"
  }, {
    path: "/ja_jp/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___ja_jp"
  }, {
    path: "/zh_hk/checkout/error-page",
    component: _a842437e,
    name: "error-page___zh_hk"
  }, {
    path: "/zh_hk/checkout/thank-you",
    component: _4af5c43b,
    name: "thank-you___zh_hk"
  }, {
    path: "/de_eu/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___de_eu"
  }, {
    path: "/de_eu/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___de_eu"
  }, {
    path: "/de_eu/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___de_eu"
  }, {
    path: "/en_eu/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___en_eu"
  }, {
    path: "/en_eu/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___en_eu"
  }, {
    path: "/en_eu/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___en_eu"
  }, {
    path: "/en_hk/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___en_hk"
  }, {
    path: "/en_hk/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___en_hk"
  }, {
    path: "/en_hk/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___en_hk"
  }, {
    path: "/en_uk/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___en_uk"
  }, {
    path: "/en_uk/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___en_uk"
  }, {
    path: "/en_uk/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___en_uk"
  }, {
    path: "/en_us/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___en_us"
  }, {
    path: "/en_us/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___en_us"
  }, {
    path: "/en_us/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___en_us"
  }, {
    path: "/en_us/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___en_us"
  }, {
    path: "/en_us/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___en_us"
  }, {
    path: "/en_us/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___en_us"
  }, {
    path: "/es_eu/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___es_eu"
  }, {
    path: "/es_eu/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___es_eu"
  }, {
    path: "/es_eu/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___es_eu"
  }, {
    path: "/fr_eu/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___fr_eu"
  }, {
    path: "/fr_eu/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___fr_eu"
  }, {
    path: "/fr_eu/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___fr_eu"
  }, {
    path: "/fr_fr/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___fr_fr"
  }, {
    path: "/fr_fr/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___fr_fr"
  }, {
    path: "/fr_fr/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___fr_fr"
  }, {
    path: "/fr_us/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___fr_us"
  }, {
    path: "/fr_us/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___fr_us"
  }, {
    path: "/fr_us/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___fr_us"
  }, {
    path: "/fr_us/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___fr_us"
  }, {
    path: "/fr_us/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___fr_us"
  }, {
    path: "/fr_us/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___fr_us"
  }, {
    path: "/it_eu/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___it_eu"
  }, {
    path: "/it_eu/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___it_eu"
  }, {
    path: "/it_eu/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___it_eu"
  }, {
    path: "/ja_jp/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___ja_jp"
  }, {
    path: "/ja_jp/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___ja_jp"
  }, {
    path: "/ja_jp/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___ja_jp"
  }, {
    path: "/zh_hk/api/adyen/handleShopperRedirect",
    component: _30614006,
    name: "after-payment-redirect___zh_hk"
  }, {
    path: "/zh_hk/np_gmopayment/linktypeplus/result",
    component: _7d2a12c3,
    name: "gmo-linktypeplus-result___zh_hk"
  }, {
    path: "/zh_hk/np_gmopayment/threedsecure/result",
    component: _28c16772,
    name: "gmo-threedsecure-result___zh_hk"
  }, {
    path: "/de_eu/c/:slug+.html",
    component: _749b627f,
    name: "c-page___de_eu"
  }, {
    path: "/de_eu/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___de_eu"
  }, {
    path: "/de_eu/page/:slug+",
    component: _749b627f,
    name: "page___de_eu"
  }, {
    path: "/de_eu/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___de_eu"
  }, {
    path: "/en_eu/c/:slug+.html",
    component: _749b627f,
    name: "c-page___en_eu"
  }, {
    path: "/en_eu/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___en_eu"
  }, {
    path: "/en_eu/page/:slug+",
    component: _749b627f,
    name: "page___en_eu"
  }, {
    path: "/en_eu/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___en_eu"
  }, {
    path: "/en_hk/c/:slug+.html",
    component: _749b627f,
    name: "c-page___en_hk"
  }, {
    path: "/en_hk/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___en_hk"
  }, {
    path: "/en_hk/page/:slug+",
    component: _749b627f,
    name: "page___en_hk"
  }, {
    path: "/en_hk/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___en_hk"
  }, {
    path: "/en_uk/c/:slug+.html",
    component: _749b627f,
    name: "c-page___en_uk"
  }, {
    path: "/en_uk/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___en_uk"
  }, {
    path: "/en_uk/page/:slug+",
    component: _749b627f,
    name: "page___en_uk"
  }, {
    path: "/en_uk/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___en_uk"
  }, {
    path: "/en_us/c/:slug+.html",
    component: _749b627f,
    name: "c-page___en_us"
  }, {
    path: "/en_us/c/:slug+.html",
    component: _749b627f,
    name: "c-page___en_us"
  }, {
    path: "/en_us/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___en_us"
  }, {
    path: "/en_us/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___en_us"
  }, {
    path: "/en_us/page/:slug+",
    component: _749b627f,
    name: "page___en_us"
  }, {
    path: "/en_us/page/:slug+",
    component: _749b627f,
    name: "page___en_us"
  }, {
    path: "/en_us/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___en_us"
  }, {
    path: "/en_us/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___en_us"
  }, {
    path: "/es_eu/c/:slug+.html",
    component: _749b627f,
    name: "c-page___es_eu"
  }, {
    path: "/es_eu/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___es_eu"
  }, {
    path: "/es_eu/page/:slug+",
    component: _749b627f,
    name: "page___es_eu"
  }, {
    path: "/es_eu/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___es_eu"
  }, {
    path: "/fr_eu/c/:slug+.html",
    component: _749b627f,
    name: "c-page___fr_eu"
  }, {
    path: "/fr_eu/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___fr_eu"
  }, {
    path: "/fr_eu/page/:slug+",
    component: _749b627f,
    name: "page___fr_eu"
  }, {
    path: "/fr_eu/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___fr_eu"
  }, {
    path: "/fr_fr/c/:slug+.html",
    component: _749b627f,
    name: "c-page___fr_fr"
  }, {
    path: "/fr_fr/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___fr_fr"
  }, {
    path: "/fr_fr/page/:slug+",
    component: _749b627f,
    name: "page___fr_fr"
  }, {
    path: "/fr_fr/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___fr_fr"
  }, {
    path: "/fr_us/c/:slug+.html",
    component: _749b627f,
    name: "c-page___fr_us"
  }, {
    path: "/fr_us/c/:slug+.html",
    component: _749b627f,
    name: "c-page___fr_us"
  }, {
    path: "/fr_us/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___fr_us"
  }, {
    path: "/fr_us/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___fr_us"
  }, {
    path: "/fr_us/page/:slug+",
    component: _749b627f,
    name: "page___fr_us"
  }, {
    path: "/fr_us/page/:slug+",
    component: _749b627f,
    name: "page___fr_us"
  }, {
    path: "/fr_us/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___fr_us"
  }, {
    path: "/fr_us/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___fr_us"
  }, {
    path: "/it_eu/c/:slug+.html",
    component: _749b627f,
    name: "c-page___it_eu"
  }, {
    path: "/it_eu/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___it_eu"
  }, {
    path: "/it_eu/page/:slug+",
    component: _749b627f,
    name: "page___it_eu"
  }, {
    path: "/it_eu/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___it_eu"
  }, {
    path: "/ja_jp/c/:slug+.html",
    component: _749b627f,
    name: "c-page___ja_jp"
  }, {
    path: "/ja_jp/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___ja_jp"
  }, {
    path: "/ja_jp/page/:slug+",
    component: _749b627f,
    name: "page___ja_jp"
  }, {
    path: "/ja_jp/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___ja_jp"
  }, {
    path: "/zh_hk/c/:slug+.html",
    component: _749b627f,
    name: "c-page___zh_hk"
  }, {
    path: "/zh_hk/category-preview/:slug_1?",
    component: _46857d16,
    name: "category-preview___zh_hk"
  }, {
    path: "/zh_hk/page/:slug+",
    component: _749b627f,
    name: "page___zh_hk"
  }, {
    path: "/zh_hk/product-preview/:slug_1?",
    component: _106cd748,
    name: "product-preview___zh_hk"
  }, {
    path: "/de_eu/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___de_eu"
  }, {
    path: "/en_eu/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___en_eu"
  }, {
    path: "/en_hk/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___en_hk"
  }, {
    path: "/en_uk/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___en_uk"
  }, {
    path: "/en_us/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___en_us"
  }, {
    path: "/en_us/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___en_us"
  }, {
    path: "/es_eu/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___es_eu"
  }, {
    path: "/fr_eu/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___fr_eu"
  }, {
    path: "/fr_fr/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___fr_fr"
  }, {
    path: "/fr_us/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___fr_us"
  }, {
    path: "/fr_us/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___fr_us"
  }, {
    path: "/it_eu/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___it_eu"
  }, {
    path: "/ja_jp/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___ja_jp"
  }, {
    path: "/zh_hk/l/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: _46857d16,
    name: "category___zh_hk"
  }, {
    path: "/de_eu/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___de_eu"
  }, {
    path: "/en_eu/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___en_eu"
  }, {
    path: "/en_hk/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___en_hk"
  }, {
    path: "/en_uk/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___en_uk"
  }, {
    path: "/en_us/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___en_us"
  }, {
    path: "/en_us/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___en_us"
  }, {
    path: "/es_eu/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___es_eu"
  }, {
    path: "/fr_eu/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___fr_eu"
  }, {
    path: "/fr_fr/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___fr_fr"
  }, {
    path: "/fr_us/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___fr_us"
  }, {
    path: "/fr_us/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___fr_us"
  }, {
    path: "/it_eu/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___it_eu"
  }, {
    path: "/ja_jp/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___ja_jp"
  }, {
    path: "/zh_hk/p/:slug/:slug_2?/:slug_3?/:slug_4?/:slug_5?/:slug_6?/:slug_7?",
    component: _106cd748,
    name: "product___zh_hk"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
